module.exports = __webpack_public_path__ + "section/burger/img/logo-print.png?hash=82b99d55ab25df8d97b140dfc65c19de"


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/asset-loader!./LeLab.LogAlto.Web/src/modules/section/burger/img/logo-print.png
 ** module id = 20
 ** module chunks = 0 1
 **/